import React, { FC } from 'react'
import { IHistoryAnnualTotal } from '../../../../interfaces/IHistory'
import { roundTwoDecimals } from '../../../../utils/helpers'
import DynamicFormattedMessage from '../../../common/ui/DynamicFormattedMessage'

export const SemesterTableRow: FC<IHistoryAnnualTotal> = ({
  currentYear,
  previousYear,
  name,
  customClass = '',
  rafQty,
}) => {
  return (
    <tr className={`textPrimary textCustomXs ${customClass}`}>
      <td>
        {name || (
          <DynamicFormattedMessage
            id="page.history.annual.total"
            className="textUppercase"
          />
        )}
      </td>
      <td className="textCenter">{currentYear?.S1?.quantity || '-'}</td>
      <td className="textCenter">{currentYear?.S2?.quantity || '-'}</td>
      <td className="textCenter">
        {roundTwoDecimals(currentYear?.S1?.value) || '-'}
      </td>
      <td className="textCenter">
        {roundTwoDecimals(currentYear?.S2?.value) || '-'}
      </td>
      <td className="textCenter">{previousYear?.S1?.quantity || '-'}</td>
      <td className="textCenter">{previousYear?.S2?.quantity || '-'}</td>
      <td className="textCenter">
        {roundTwoDecimals(previousYear?.S1?.value) || '-'}
      </td>
      <td className="textCenter">
        {roundTwoDecimals(previousYear?.S2?.value) || '-'}
      </td>
      <td className="textCenter">{rafQty}</td>
    </tr>
  )
}
